"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiotBreakerAbilityHandler = exports.RiotBreakerActorAbilityFactory = exports.RiotBreakerAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class RiotBreakerAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.RiotBreaker;
        this.__typeName = "RiotBreaker";
    }
}
exports.RiotBreakerAbilityArgs = RiotBreakerAbilityArgs;
let RiotBreakerActorAbilityFactory = class RiotBreakerActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("RiotBreaker", "OneEnemies", 2);
    }
};
RiotBreakerActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("RiotBreaker")
], RiotBreakerActorAbilityFactory);
exports.RiotBreakerActorAbilityFactory = RiotBreakerActorAbilityFactory;
let RiotBreakerAbilityHandler = class RiotBreakerAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 100)
            ],
            onHit: (sequence) => {
                const roll = (0, Random_1.randomPercent)();
                if (roll <= 25) {
                    container.applyDebuff({
                        attackerId: ability.invokerId,
                        targetId,
                        sequence,
                        duration: Duration_1.Duration.Turns(2),
                        effect: new core_1.StunEffectArgs()
                    });
                }
                else if (roll <= 50) {
                    container.applyDebuff({
                        attackerId: ability.invokerId,
                        targetId,
                        sequence,
                        duration: Duration_1.Duration.Turns(8),
                        effect: new core_1.VulnerabilityEffectArgs(3)
                    });
                }
            }
        });
    }
};
RiotBreakerAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.RiotBreaker)
], RiotBreakerAbilityHandler);
exports.RiotBreakerAbilityHandler = RiotBreakerAbilityHandler;
